// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"249":"7eddd119","388":"1042c50d"}[chunkId] + ".chunk.js";
};